// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueClipBoard from 'vue-clipboard2'
import Antd, { Icon } from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.less';
import 'ant-design-vue/dist/antd.css';
import iconfrontjs from './assets/iconfont/iconfont.js'
const MyIcon = Icon.createFromIconfontCN({
  scriptUrl: iconfrontjs,
});
Vue.component("my-icon", MyIcon);

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VueClipBoard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js